import React from 'react';
//import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import navigateBackground from './../images/kpit_navigate.png';
import kpitLogo from './../images/kpit_logo_new.png';
import simulib from './../images/simulib_icon.png';
import sceneGen from './../images/scene_gen_icon.png';
import automateKpi from './../images/automate_kpi_icon.png';


const Navigate = () => (

    <div data-test = 'navigateComponent'>
        <div className="container">
            <div className="row" style={{ paddingTop: "5%" }}>
                <div className="col-md-12" style={{  textAlign: "center" }}>
                    <img src={kpitLogo} alt="" />
                </div>
            </div>
            <div className="row" style={{ paddingTop: "8%" }}>
                <div className="col-md-12" style={{ textAlign: "center" }}>
                    <h2>Welcome!</h2>
                </div>
            </div>
            <div className="row" style={{ paddingTop: "6%" }}>
                <div className="col-md-4">
                    <Link to="/welcome_scenario_catalogue">
                        <div className="card" id="info-box">
                            <div className="card-body" style={{ textAlign: "center" }}>
                                <img src={simulib} style={{ width: "68%" }} alt=""/>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-md-4">
                    <div className="card" id="info-box">
                        <div className="card-body" style={{ textAlign: "center" }}>
                            <img src={sceneGen} alt="" style={{ width: "74%" }}/>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card" id="info-box">
                        <div className="card-body" style={{ textAlign: "center" }}>
                            <img src={automateKpi} alt="" style={{ width: "100%" }}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

export default Navigate;
